import { createActions } from 'redux-actions';

export const { editWish, updateEdits, clearEditWish } = createActions({
  EDIT_WISH: wishId => wishId,
  UPDATE_EDITS: (wishId, edits) => ({ wishId, edits }),
  CLEAR_EDIT_WISH: wishId => wishId
});



// WEBPACK FOOTER //
// ./src/store/editWish/actions.js